import { render, staticRenderFns } from "./TemplateCopyfrom.vue?vue&type=template&id=7618dc74&scoped=true"
import script from "./TemplateCopyfrom.vue?vue&type=script&lang=js"
export * from "./TemplateCopyfrom.vue?vue&type=script&lang=js"
import style0 from "./TemplateCopyfrom.vue?vue&type=style&index=0&id=7618dc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618dc74",
  null
  
)

export default component.exports